vue
<template>
  <div class="daikuanxinxi-layer">
    <!-- 标题区域 -->
    <div class="header-section">
      <h2 class="page-title">贷款信息</h2>
      <p class="page-subtitle">请填写您的贷款需求信息，用于信用风险评估</p>
    </div>

    <!-- 主要内容区域 -->
    <div class="content-container">
      <!-- 贷款基本信息 -->
      <div class="form-section">
        <div class="section-title">
          <span class="title-icon"></span>
          <h3>贷款信息（模拟场景利率水平：1年期LPR为3.0%，5年期LPR为3.5%）</h3>
        </div>

        <div class="form-grid">
          <!-- 申请金额 -->
          <div class="form-item">
            <label class="form-label">申请金额（元）</label>
            <el-input 
              v-model="loadInfo.loanAmount" 
              placeholder="请输入申请金额"
              class="income-input"
              @input="validateLoanAmount">
              <template slot="append">元</template>
            </el-input>
          </div>

          <!-- 期数 -->
          <div class="form-item">
            <label class="form-label">期数</label>
            <el-input 
              v-model="loadInfo.loanTerm" 
              placeholder="请输入期数" 
              class="income-input"
              @input="validateLoanTerm"
              :maxlength="3">
              <template slot="append">月</template>
            </el-input>
          </div>

          <!-- 用途 -->
          <div class="form-item">
            <label class="form-label">贷款用途</label>
            <el-select v-model="loadInfo.loanPurpose" placeholder="请选择贷款用途" class="loan-select">
              <el-option label="购房/装修" value="购房/装修"></el-option>
              <el-option label="购车" value="购车"></el-option>
              <el-option label="教育/医疗" value="教育/医疗"></el-option>
              <el-option label="日常消费" value="日常消费"></el-option>
              <el-option label="流动资金周转" value="流动资金周转"></el-option>
              <el-option label="设备/原材料采购" value="设备/原材料采购"></el-option>
              <el-option label="项目投资" value="项目投资"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </div>

          <!-- 还款方式 -->
          <div class="form-item">
            <label class="form-label">还款方式</label>
            <el-select v-model="loadInfo.repaymentMethod" placeholder="请选择还款方式" class="loan-select">
              <el-option label="等额本息" value="等额本息"></el-option>
              <el-option label="等额本金" value="等额本金"></el-option>
            </el-select>
          </div>

          <!-- 预览计算-->
          <div class="form-btn">
            <button class="preview-btn" @click="previewPayment"><i class="el-icon-cpu"
                 style="margin-right: 5px;"></i>预览计算</button>
          </div>
        </div>
      </div>

      <!-- 贷款详情：等额本金/等额本金 -->
      <div class="form-section">
        <div class="section-title">
          <span class="title-icon"></span>
          <h3>贷款详情：<span>{{ loadInfo.repaymentMethod }}</span></h3>
        </div>

        <div class="form-grid">
          <el-table :data="tableData" style="width: 100%" v-if="tableData.length > 0">
            <el-table-column prop="month" label="期数"></el-table-column>
            <el-table-column prop="payment" label="月还款额"></el-table-column>
            <el-table-column prop="principal" label="本金"></el-table-column>
            <el-table-column prop="interest" label="利息"></el-table-column>
            <el-table-column prop="remaining" label="剩余本金"></el-table-column>
          </el-table>
          
          <div v-if="tableData.length > 0" class="repayment-summary">
            <div class="summary-item">
              <span class="summary-label">贷款总额：</span>
              <span class="summary-value">¥{{ parseFloat(loadInfo.loanAmount).toLocaleString() }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">总利息：</span>
              <span class="summary-value">¥{{ calculateTotalInterest().toLocaleString() }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">总还款：</span>
              <span class="summary-value">¥{{ calculateTotalPayment().toLocaleString() }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="action-section">
        <el-button class="prev-btn" @click="handlePrev">
          上一步
        </el-button>
        <el-button class="reset-btn" @click="handleReset">
          重置
        </el-button>
        <el-button type="primary" class="submit-btn" @click="handleSubmit">
          下一步
        </el-button>
      </div>
    </div>

    <div class="dd-inner" v-show="loading">
      <zdyloading style="width: 200px;" ref="zdyloading" :isShowLoading="loading" loadingTxt="个人征信报告正在生成中，请稍后...">
      </zdyloading>
    </div>

  </div>
</template>

<script>
import Zdyloading from '@/components/Zdyloading.vue'
export default {
  name: 'daikuanxinxi',
  components: { Zdyloading },
  props: {},
  data () {
    return {
      loading: false,
      loadInfo:{
        loanAmount: '', // 申请金额
        loanTerm: '', // 期数
        loanPurpose: '', // 贷款用途
        repaymentMethod: '', // 还款方式
      },
      tableData: [], // 还款计划表格数据
    }
  },
  computed: {
    repaymentMethod () {
      return this.loadInfo.repaymentMethod;
    }
  },
  watch: {

  },
  created () {
    this.initData();
  },
  mounted () {
    // 从sessionStorage中获取贷款信息
    const loanInfo = sessionStorage.getItem('loanInfo');
    if (loanInfo) {
      this.loadInfo = JSON.parse(loanInfo);
    }
  },
  methods: {
    // 验证贷款金额（只能输入大于0的数字，最多两位小数）
    validateLoanAmount(value) {
      // 移除非数字字符（保留小数点）
      let cleanValue = value.replace(/[^0-9.]/g, '');
      
      // 确保只有一个小数点
      const parts = cleanValue.split('.');
      if (parts.length > 2) {
        cleanValue = parts[0] + '.' + parts.slice(1).join('');
      }
      
      // 限制小数位数（最多2位）
      if (parts.length === 2 && parts[1].length > 2) {
        cleanValue = parts[0] + '.' + parts[1].substring(0, 2);
      }
      
      // 限制最大值（1000万）
      if (cleanValue && parseFloat(cleanValue) > 10000000) {
        cleanValue = '10000000';
      }
      
      // 确保大于0
      if (cleanValue && parseFloat(cleanValue) <= 0) {
        cleanValue = '';
      }
      
      // 更新模型值
      this.$nextTick(() => {
        this.loadInfo.loanAmount = cleanValue;
      });
    },
    
    // 验证贷款期数（只能输入正整数）
    validateLoanTerm(value) {
      // 移除非数字字符
      let cleanValue = value.replace(/[^0-9]/g, '');
      
      // 限制在合理范围内（1-360个月，即30年）
      if (cleanValue) {
        const numValue = parseInt(cleanValue);
        if (numValue > 360) {
          cleanValue = '360';
        } else if (numValue < 1 && cleanValue !== '0') {
          cleanValue = '';
        } else if (numValue === 0) {
          cleanValue = '';
        }
      }
      
      // 更新模型值
      this.$nextTick(() => {
        this.loadInfo.loanTerm = cleanValue;
      });
    },
    
    // 验证贷款表单
    validateLoanForm() {
      // 验证贷款金额
      if (!this.loadInfo.loanAmount) {
        this.$message.warning('请输入贷款金额');
        return false;
      }
      
      const loanAmount = parseFloat(this.loadInfo.loanAmount);
      if (isNaN(loanAmount) || loanAmount <= 0) {
        this.$message.warning('请输入有效的贷款金额');
        return false;
      }
      
      if (loanAmount > 10000000) {
        this.$message.warning('贷款金额不能超过1000万元');
        return false;
      }
      
      // 验证贷款期数
      if (!this.loadInfo.loanTerm) {
        this.$message.warning('请输入贷款期数');
        return false;
      }
      
      const loanTerm = parseInt(this.loadInfo.loanTerm);
      if (isNaN(loanTerm) || loanTerm <= 0) {
        this.$message.warning('请输入有效的贷款期数');
        return false;
      }
      
      if (loanTerm > 360) {
        this.$message.warning('贷款期数不能超过360个月（30年）');
        return false;
      }
      
      // 验证贷款用途
      if (!this.loadInfo.loanPurpose) {
        this.$message.warning('请选择贷款用途');
        return false;
      }
      
      // 验证还款方式
      if (!this.loadInfo.repaymentMethod) {
        this.$message.warning('请选择还款方式');
        return false;
      }
      
      return true;
    },

    // 提交表单
    handleSubmit () {
      // 验证表单数据
      if (!this.validateLoanForm()) {
        return;
      }

      sessionStorage.setItem('loanInfo', JSON.stringify(this.loadInfo));

      const formData = {
        loanAmount: this.loadInfo.loanAmount,
        loanTerm: this.loadInfo.loanTerm,
        loanPurpose: this.loadInfo.loanPurpose,
        repaymentMethod: this.loadInfo.repaymentMethod
      };
      console.log('提交的贷款信息:', formData);

      // 显示loading
      this.loading = true;
      setTimeout(() => {
        // 隐藏loading
        this.loading = false;
        this.$message({
          message: '贷款信息提交成功！',
          type: 'success'
        });
        // 触发下一步事件
        this.$emit('nextStep', 'monigerenzhengxinbaogao');
      }, 2000);
    },

    // 重置表单
    handleReset () {
      this.loadInfo.loanAmount = '';
      this.loadInfo.loanTerm = '';
      this.loadInfo.loanPurpose = '';
      this.loadInfo.repaymentMethod = '';
      sessionStorage.removeItem('loanInfo');
      this.tableData = [];

      sessionStorage.removeItem('loanInfo');
      this.$message({
        message: '表单已重置！',
        type: 'info'
      });
    },

    // 上一步
    handlePrev () {
      this.$emit('nextStep', 'gerenyushouruxinxi');
    },

    // 预览计算
    previewPayment () {
      // 验证表单数据
      if (!this.validateLoanForm()) {
        return;
      }

      // 计算还款计划
      this.updateRepaymentSchedule();

      this.$message({
        message: '还款计划已更新！',
        type: 'success'
      });

      // 滚动到表格区域
      this.$nextTick(() => {
        const tableSection = document.querySelector('.form-section:nth-child(2)');
        if (tableSection) {
          tableSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    },

    // 更新还款计划
    updateRepaymentSchedule () {
      const { loanAmount, loanTerm, repaymentMethod } = this.loadInfo;
      
      // 验证输入数据
      if (!loanAmount || !loanTerm || !repaymentMethod) {
        return;
      }
      
      // 计算还款信息
      const paymentInfo = this.calculateMonthlyPayment(parseFloat(loanAmount), parseInt(loanTerm), repaymentMethod);
      
      // 生成还款计划表
      this.tableData = this.generateRepaymentSchedule(parseFloat(loanAmount), parseInt(loanTerm), paymentInfo);
      
      // 在控制台输出计算结果供调试
      console.log(`贷款金额: ¥${loanAmount}, 期限: ${loanTerm}个月, 方式: ${repaymentMethod}`);
      console.log(`总利息: ¥${paymentInfo.totalInterest.toFixed(2)}`);
      console.log(`总还款: ¥${paymentInfo.totalPayment.toFixed(2)}`);
    },

    // 计算总利息
    calculateTotalInterest () {
      if (this.tableData.length === 0) return 0;
      return this.tableData.reduce((total, item) => {
        return total + parseFloat(item.interest.replace(/[¥,]/g, ''));
      }, 0);
    },
    
    // 计算总还款
    calculateTotalPayment () {
      if (this.tableData.length === 0) return 0;
      return this.tableData.reduce((total, item) => {
        return total + parseFloat(item.payment.replace(/[¥,]/g, ''));
      }, 0);
    },
    
    // 分别计算等额本息和等额本金 1年期LPR为3.0%，5年期以上LPR为3.5%
    calculateMonthlyPayment (loanAmount, loanTerm, repaymentMethod) {
      // 根据贷款期限确定利率
      const annualRate = loanTerm <= 12 ? 0.03 : 0.035; // 1年期3.0%，5年期以上3.5%
      const monthlyRate = annualRate / 12; // 月利率
      
      if (repaymentMethod === '等额本息') {
        // 等额本息计算公式：每月还款额 = [贷款本金 × 月利率 × (1 + 月利率)^还款月数] ÷ [(1 + 月利率)^还款月数 - 1]
        const monthlyPayment = (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, loanTerm)) / 
                              (Math.pow(1 + monthlyRate, loanTerm) - 1);
        return {
          type: '等额本息',
          monthlyPayment: monthlyPayment,
          monthlyRate: monthlyRate,
          totalPayment: monthlyPayment * loanTerm,
          totalInterest: monthlyPayment * loanTerm - loanAmount
        };
      } else if (repaymentMethod === '等额本金') {
        // 等额本金计算公式：每月还款额 = (贷款本金 ÷ 还款月数) + (本金 - 已归还本金累计额) × 月利率
        const monthlyPrincipal = loanAmount / loanTerm; // 每月本金
        const firstMonthPayment = monthlyPrincipal + loanAmount * monthlyRate; // 首月还款
        const lastMonthPayment = monthlyPrincipal + monthlyPrincipal * monthlyRate; // 末月还款
        const totalInterest = (loanAmount * monthlyRate * (loanTerm + 1)) / 2; // 总利息
        
        return {
          type: '等额本金',
          monthlyPrincipal: monthlyPrincipal,
          monthlyRate: monthlyRate,
          firstMonthPayment: firstMonthPayment,
          lastMonthPayment: lastMonthPayment,
          totalPayment: loanAmount + totalInterest,
          totalInterest: totalInterest
        };
      }
    },
    
    // 生成还款计划表
    generateRepaymentSchedule (loanAmount, loanTerm, paymentInfo) {
      const schedule = [];
      
      if (paymentInfo.type === '等额本息') {
        // 等额本息还款计划
        let remainingPrincipal = loanAmount;
        const monthlyPayment = paymentInfo.monthlyPayment;
        
        for (let month = 1; month <= loanTerm; month++) {
          const interestPayment = remainingPrincipal * paymentInfo.monthlyRate;
          const principalPayment = monthlyPayment - interestPayment;
          remainingPrincipal -= principalPayment;
          
          schedule.push({
            month: `第${month}期`,
            payment: `¥${monthlyPayment.toFixed(2)}`,
            principal: `¥${principalPayment.toFixed(2)}`,
            interest: `¥${interestPayment.toFixed(2)}`,
            remaining: `¥${Math.max(0, remainingPrincipal).toFixed(2)}`
          });
        }
      } else if (paymentInfo.type === '等额本金') {
        // 等额本金还款计划
        let remainingPrincipal = loanAmount;
        const monthlyPrincipal = paymentInfo.monthlyPrincipal;
        
        for (let month = 1; month <= loanTerm; month++) {
          const interestPayment = remainingPrincipal * paymentInfo.monthlyRate;
          const monthlyPayment = monthlyPrincipal + interestPayment;
          remainingPrincipal -= monthlyPrincipal;
          
          schedule.push({
            month: `第${month}期`,
            payment: `¥${monthlyPayment.toFixed(2)}`,
            principal: `¥${monthlyPrincipal.toFixed(2)}`,
            interest: `¥${interestPayment.toFixed(2)}`,
            remaining: `¥${Math.max(0, remainingPrincipal).toFixed(2)}`
          });
        }
      }
      
      return schedule;
    },
  
  }
}
</script>

<style scoped lang="less">
.daikuanxinxi-layer {
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
}

// 标题区域
.header-section {
  text-align: center;
  margin-bottom: 30px;
  // padding: 20px 0;

  .page-title {
    font-size: 28px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 10px;
  }

  .page-subtitle {
    font-size: 16px;
    color: #b8c4e0;
    margin: 0;
  }
}

// 内容容器
.content-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

// 表单区域
.form-section {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 20px;
  border: 1px solid rgba(21, 73, 243, 0.2);

  .section-title {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(21, 73, 243, 0.2);

    .title-icon {
      width: 4px;
      height: 20px;
      background: linear-gradient(135deg, #1549F3 0%, #1890ff 100%);
      border-radius: 2px;
      margin-right: 12px;
    }

    h3 {
      font-size: 18px;
      color: #fff;
      margin: 0;
      font-weight: 600;
    }
  }
}

// 表单网格
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .form-label {
    font-size: 14px;
    color: #b8c4e0;
    font-weight: 500;
  }
}

.form-btn {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}

// 输入框样式
.income-input {
  /deep/.el-input__inner {
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
    color: #fff;
    font-size: 14px;

    &::placeholder {
      color: rgba(184, 196, 224, 0.6);
    }

    &:focus {
      border-color: #1549F3;
      box-shadow: 0 0 0 2px rgba(21, 73, 243, 0.2);
    }
  }

  /deep/.el-input-group__append {
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-left: none;
    color: #b8c4e0;
    border-radius: 0 8px 8px 0;
  }
}

// 预览计算按钮样式
.preview-btn {
  background: #fff;
  border: 1px solid rgba(21, 73, 243, 0.3);
  border-radius: 8px;
  color: #1549F3;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
  height: 40px;

  &:hover {
    background: rgba(255, 255, 255, 0.9);
    border-color: #1549F3;
    box-shadow: 0 2px 8px rgba(21, 73, 243, 0.2);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 4px rgba(21, 73, 243, 0.2);
  }

  &:focus {
    outline: none;
    border-color: #1549F3;
    box-shadow: 0 0 0 2px rgba(21, 73, 243, 0.2);
  }
}

// 数字输入框样式
.loan-input-number {
  /deep/.el-input__inner {
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
    color: #fff;
    font-size: 14px;
    height: 40px;
    line-height: 40px;

    &::placeholder {
      color: rgba(184, 196, 224, 0.6);
    }

    &:focus {
      border-color: #1549F3;
      box-shadow: 0 0 0 2px rgba(21, 73, 243, 0.2);
    }
  }

  /deep/.el-input-number__increase,
  /deep/.el-input-number__decrease {
    background: rgba(0, 0, 0, 0.3);
    border-color: rgba(21, 73, 243, 0.3);
    color: #b8c4e0;

    &:hover {
      color: #fff;
      background: rgba(21, 73, 243, 0.2);
    }
  }
}

// 还款汇总样式
.repayment-summary {
  margin-top: 20px;
  padding: 20px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  border: 1px solid rgba(21, 73, 243, 0.2);
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 15px;

  .summary-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;

    .summary-label {
      font-size: 14px;
      color: #b8c4e0;
      font-weight: 500;
    }

    .summary-value {
      font-size: 18px;
      color: #fff;
      font-weight: 600;
      color: #1890ff;
    }
  }
}

// 选择框样式
.loan-select {
  /deep/.el-input__inner {
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
    color: #fff;
    font-size: 14px;
    height: 40px;
    line-height: 40px;

    &:focus {
      border-color: #1549F3;
      box-shadow: 0 0 0 2px rgba(21, 73, 243, 0.2);
    }
  }

  /deep/.el-select-dropdown {
    background: rgba(0, 18, 64, 0.95);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
  }

  /deep/.el-select-dropdown__item {
    color: #b8c4e0;
    height: 36px;
    line-height: 36px;

    &:hover {
      background: rgba(21, 73, 243, 0.2);
    }

    &.selected {
      color: #fff;
      background: rgba(21, 73, 243, 0.3);
    }
  }
}

// 评估区域
.assessment-section {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 20px;
  border: 1px solid rgba(21, 73, 243, 0.2);

  .section-title {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(21, 73, 243, 0.2);

    .title-icon {
      width: 4px;
      height: 20px;
      background: linear-gradient(135deg, #1549F3 0%, #1890ff 100%);
      border-radius: 2px;
      margin-right: 12px;
    }

    h3 {
      font-size: 18px;
      color: #fff;
      margin: 0;
      font-weight: 600;
    }
  }
}

// 评估网格
.assessment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.assessment-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  border: 1px solid rgba(21, 73, 243, 0.1);

  .assessment-label {
    font-size: 14px;
    color: #b8c4e0;
    min-width: 60px;
    font-weight: 500;
  }

  .assessment-progress {
    flex: 1;

    /deep/.el-progress-bar__outer {
      background: rgba(0, 0, 0, 0.3);
      border-radius: 4px;
    }

    /deep/.el-progress-bar__inner {
      border-radius: 4px;
    }
  }

  .assessment-value {
    font-size: 16px;
    color: #fff;
    font-weight: 600;
    min-width: 50px;
    text-align: right;
  }

  .risk-level {
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    min-width: 80px;

    &.risk-low {
      background: rgba(82, 196, 26, 0.2);
      color: #52c41a;
      border: 1px solid rgba(82, 196, 26, 0.3);
    }

    &.risk-medium {
      background: rgba(250, 173, 20, 0.2);
      color: #faad14;
      border: 1px solid rgba(250, 173, 20, 0.3);
    }

    &.risk-high {
      background: rgba(245, 34, 45, 0.2);
      color: #f5222d;
      border: 1px solid rgba(245, 34, 45, 0.3);
    }
  }
}

// 操作区域
.action-section {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid rgba(21, 73, 243, 0.2);

  .submit-btn {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: bold;
    background: linear-gradient(135deg, #1549F3 0%, #1890ff 100%);
    border: none;
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(21, 73, 243, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .reset-btn {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
    color: #b8c4e0;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(21, 73, 243, 0.2);
      color: #fff;
    }
  }

  .prev-btn {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
    color: #b8c4e0;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(21, 73, 243, 0.2);
      color: #fff;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .content-container {
    padding: 0 10px;
  }

  .form-grid,
  .assessment-grid {
    grid-template-columns: 1fr;
  }

  .form-section,
  .assessment-section {
    padding: 20px;
  }

  .action-section {
    flex-direction: column;
    align-items: center;

    .submit-btn,
    .reset-btn,
    .prev-btn {
      width: 200px;
    }
  }

  .assessment-item {
    flex-direction: column;
    text-align: center;
    gap: 10px;

    .assessment-label,
    .assessment-value {
      min-width: auto;
    }
  }

  // 移动端预览按钮优化
  .preview-btn {
    width: 100%;
    padding: 12px 20px;
    font-size: 16px;
  }
}

.dd-inner {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 6, 36, 0.6);

  /deep/ .loading-text {
    color: #fff;
  }
}
</style>
